import React from 'react';

import { ReactComponent as SoccerBall } from '../../icons/svg/soccer-ball.svg';

import './LoadingBall.css';

type Props = {
  width?: number;
  height?: number;
  className?: string;
};

const LoadingBall = ({ width = 100, height = 100, className }: Props) => (
  <div
    className={className}
    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
  >
    <SoccerBall className="rotating" style={{ width, height }} />
  </div>
);

export default LoadingBall;
